const ANALITICS = {
  newAnalitics: "new stat",
  editAnalitics: "Edit Statistics",
  listAnalitics: "Statistics list",
  newAnalitic: "New Statistics Dashboard",
  alert: "Remember not to use <strong>special characters</strong>.",
  placeholderName: "Name",
  placeHolderUri: "Enter the dashboard url",
  save: "Save",
  clean: "Clean",  

  name: "Statistics",
  url: "url",
  company: "Company",
  status: "Status",
  actions: "Actions",
  selectCompany: "Select a company",

  notifyName: "Enter a name for the stat",
  notifyNameInvalid: "Please enter a valid name.",
  successStatistics: "Statistics created successfully!",
  updateSuccessStatistic: "Successful update",
  erroStatistics: "An error occurred while creating the statistics",

  emptyStatistic: "There are no statistics recorded.",
  deleteStatistic: "Delete Statistics:",
  alertMessage: "This option cannot be undone, are you sure?",

  accept: "Accept",
  cancel: "Cancel",
  update: "Update",

  deleteStatistics: "Delete statistics",
  NotAutorization: "You do not have permissions to perform this action.",
  erroToDelete: "An error occurred, when deleting the statistic",
  disabledAction: "Action not available at the moment",

  tableStatistic: "Study data board",
  msgErrorUrlStatistic: "The url does not belong to a valid embedded study data board."
}

export default { ANALITICS };
